import React from 'react';

interface Props {
  title: string;
}

export const SectionTitle: React.FC<Props> = ({ title }) => (
  <h1
    className="
        flex items-center text-dark-gray text-base font-semibold border-t border-solid border-whitesmoke pt-6 relative
        px-4 w-[calc(100%+2rem)] -left-4
        md:px-12 md:w-[calc(100%+6rem)] md:-left-12
        before:flex before:items-center before:justify-center before:h-7 before:w-7 before:rounded-full before:bg-navy-blue before:text-white before:mr-3
        [counter-increment:section-title] before:[content:counter(section-title)]
      "
  >
    {title}
  </h1>
);
